import { defineMessages, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { getInnerWidget } from '@plone/volto-form-block/helpers/schema';
import FormFieldWrapper from '@plone/volto-form-block/components/Wrappers/FormFieldWrapper';

const messages = defineMessages({
  required: {
    id: 'form_required',
    defaultMessage: 'Required',
  },
});

type RadioGroupWrapperProps = {
  id: string;
  title: string;
  description?: string;
  required?: boolean;
  error?: string[];
  value?: string;
  choices?: [string, string][];
  onChange: (id: string, value?: string) => void;
  onClick: () => void;
  isDisabled?: boolean;
  intl: IntlShape;
};

const RadioGroupWrapper = (props: RadioGroupWrapperProps) => {
  const {
    id,
    value,
    choices,
    onChange,
    onClick,
    isDisabled,
    title,
    description,
    required,
    error,
    intl,
  } = props;

  const Widget = getInnerWidget('radioGroup');

  const options = choices || [];

  /* START CUSTOMIZATION */
  // The designsystem radio group takes its options as a prop; upstream renders
  // them as `radioGroupOption` children, which that widget does not consume.
  return (
    <FormFieldWrapper {...props} className="text">
      <Widget
        id={`field-${id}`}
        name={id}
        value={value || undefined}
        label={title}
        description={description}
        isRequired={required}
        labelRequired={intl.formatMessage(messages.required)}
        disabled={isDisabled}
        onChange={(value: string) =>
          onChange(id, value === '' ? undefined : value)
        }
        onClick={() => onClick()}
        errorMessage={error ? error[0] : ''}
        isInvalid={error}
        options={options}
      />
    </FormFieldWrapper>
  );
  /* END CUSTOMIZATION */
};

export default injectIntl(RadioGroupWrapper);
